module.exports = __webpack_public_path__ + "img/line-b.3ac06358.svg";